import React from "react";
import { Stack, TextField, Typography, InputAdornment } from "@mui/material";

interface FormFieldProps {
  label: React.ReactNode;
  value: string;
  onChange: (value: string) => void;
  type?: string;
  placeholder?: string;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  required?: boolean;
}

export const FormField: React.FC<FormFieldProps> = ({
  label,
  value,
  onChange,
  type = "text",
  placeholder,
  error = false,
  helperText,
  disabled = false,
  startAdornment,
  endAdornment,
  required = false,
}) => {
  return (
    <Stack spacing={1}>
      <Typography variant="subtitle2">{label}</Typography>
      <TextField
        fullWidth
        type={type}
        value={value ?? ""}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        variant="outlined"
        size="small"
        disabled={disabled}
        error={error}
        helperText={helperText}
        required={required}
        sx={{
          "& .MuiOutlinedInput-root": {
            height: 44,
          },
        }}
        slotProps={{
          input: {
            startAdornment: startAdornment ? (
              <InputAdornment position="start">{startAdornment}</InputAdornment>
            ) : undefined,
            endAdornment: endAdornment ? (
              <InputAdornment position="end">{endAdornment}</InputAdornment>
            ) : undefined,
          },
        }}
      />
    </Stack>
  );
};
